import { render, staticRenderFns } from "./ModalUpdateCollection.vue?vue&type=template&id=21207838&"
import script from "./ModalUpdateCollection.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports